(function() {
  function initVideoControls() {
    document.querySelectorAll('[data-vid]').forEach(function(video) {
      if (video.dataset.vidInit) return;
      video.dataset.vidInit = '1';

      var container = video.parentElement;
      var initialPlay = container.querySelector('[data-vid-initial-play]');
      var controls = container.querySelector('[data-vid-controls]');
      if (!controls) return;

      var playPauseBtn = controls.querySelector('[data-vid-playpause]');
      var muteBtn = controls.querySelector('[data-vid-mute]');
      var fullscreenBtn = controls.querySelector('[data-vid-fullscreen]');
      var isAutoplay = video.hasAttribute('data-vid-autoplay');

      function updatePlayPause() {
        var pauseIcon = playPauseBtn.querySelector('.vid-icon--pause');
        var playIcon = playPauseBtn.querySelector('.vid-icon--play');
        pauseIcon.style.display = video.paused ? 'none' : '';
        playIcon.style.display = video.paused ? '' : 'none';
      }

      function updateMute() {
        var mutedIcon = muteBtn.querySelector('.vid-icon--muted');
        var unmutedIcon = muteBtn.querySelector('.vid-icon--unmuted');
        mutedIcon.style.display = video.muted ? '' : 'none';
        unmutedIcon.style.display = video.muted ? 'none' : '';
      }

      // For autoplay videos, show controls immediately
      if (isAutoplay) {
        controls.classList.add('is-active');
      }

      // Initial play button (big centered one)
      if (initialPlay) {
        initialPlay.addEventListener('click', function() {
          video.play();
          initialPlay.style.display = 'none';
          controls.classList.add('is-active');
          updatePlayPause();
        });
      }

      // Click video to toggle play/pause
      video.addEventListener('click', function() {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      // Play/pause button
      playPauseBtn.addEventListener('click', function() {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

      // Mute/unmute button
      muteBtn.addEventListener('click', function() {
        video.muted = !video.muted;
        updateMute();
      });

      // Fullscreen button
      fullscreenBtn.addEventListener('click', function() {
        if (video.requestFullscreen) {
          video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.webkitEnterFullscreen) {
          // iOS Safari
          video.webkitEnterFullscreen();
        }
      });

      // Sync UI on play/pause events
      video.addEventListener('play', function() {
        updatePlayPause();
        if (initialPlay) initialPlay.style.display = 'none';
      });
      video.addEventListener('pause', function() {
        updatePlayPause();
        if (initialPlay && !isAutoplay) initialPlay.style.display = '';
      });
      video.addEventListener('ended', function() {
        updatePlayPause();
        if (initialPlay && !isAutoplay) initialPlay.style.display = '';
      });

      updatePlayPause();
      updateMute();
    });
  }

  window.__vidControlsInit = initVideoControls;

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoControls);
  } else {
    initVideoControls();
  }
})();
